import { get, post, del } from './fetcher';

const CODE_ENDPOINTS = {
  GROUPS: '/api/admin/codes/groups',
  GROUP_BY_ID: (groupId) => `/api/admin/codes/groups/${groupId}`,
  CODES: '/api/admin/codes/codes',
  CODE_BY_ID: (codeId) => `/api/admin/codes/codes/${codeId}`,
};

// 코드 그룹 전체 조회
export const getCodeGroups = async (token) => {
  const response = await get(CODE_ENDPOINTS.GROUPS, {}, token);
  if (response?.success) return response.data || [];
  throw new Error(response?.message || '코드 그룹 조회에 실패했습니다.');
};

// 그룹별 코드 조회
export const getCodes = async (token, groupId) => {
  const response = await get(CODE_ENDPOINTS.CODES, { groupId }, token);
  if (response?.success) return response.data || [];
  throw new Error(response?.message || '코드 조회에 실패했습니다.');
};

// 그룹 신규/수정 (groupId 유무로 분기) → { ok, message }
export const upsertCodeGroup = async (token, row) => {
  const response = await post(CODE_ENDPOINTS.GROUPS, row, token);
  return { ok: !!response?.success, message: response?.message };
};

// 그룹 삭제 → { ok, message }
export const deleteCodeGroup = async (token, groupId) => {
  const response = await del(CODE_ENDPOINTS.GROUP_BY_ID(groupId), {}, token);
  return { ok: !!response?.success, message: response?.message };
};

// 코드 신규/수정 (codeId 유무로 분기) → { ok, message }
export const upsertCode = async (token, row) => {
  const response = await post(CODE_ENDPOINTS.CODES, row, token);
  return { ok: !!response?.success, message: response?.message };
};

// 코드 삭제 → { ok, message }
export const deleteCode = async (token, codeId) => {
  const response = await del(CODE_ENDPOINTS.CODE_BY_ID(codeId), {}, token);
  return { ok: !!response?.success, message: response?.message };
};
